<template>
  <div class="page-error">
    <div class="error-img">
      <img v-if="code === 403" class="img-403" src="./assets/403.png" alt="" />
      <img v-else src="./assets/u5009.png" alt="" />
    </div>
    <div class="error-info">
      <h3>{{ errMag }}</h3>
      <h3>跳转失败的url： {{ query.formUrl }}</h3>
      <h3>跳转失败的permissionKey： {{ query.formPermissionKey }}</h3>
      <router-link>
        <template #default="{ navigate }">
          <el-button type="primary" size="small" @click="navigate"> 返回 </el-button>
        </template>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: { code: { default: 404, type: Number }},
  computed: {
    errMag() {
      const { code } = this;
      const codeMap = {
        404: "抱歉，您当前没有权限,请联系管理员",
        500: "抱歉，服务器错误",
        403: "抱歉，您当前没有权限,请联系管理员",
        other: "未知错误"
      };
      return codeMap[code] || codeMap.other;
    },
    query() {
      return this.$route.query;
    }
  }
};
</script>
<style lang="scss" scoped>
.page-error {
  display: flex;
  width: 700px;
  justify-content: center;
  padding: 150px 0 0;
  box-sizing: border-box;
  margin: 0 auto;
  flex-flow: row nowrap;
  .error-img {
    flex: 0 0 300px;
    img {
      width: 100%;
    }
    .img-403 {
      width: auto;
    }
  }
  .error-info {
    margin-left: 30px;
    flex: 1 1;
  }
}
</style>
